<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="85%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: false,
      pageLoading: false,
      editableEntry: null,
      originalEntry: null,
      formErrors: [],
    };
  },
  props: {
    entry: Object,
    extraData: {},
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      console.log(id, this.entry);
      this.originalEntry = this.entry;
      this.editableEntry = _.cloneDeep(this.originalEntry);
      // this.editableEntry = null;
      // this.error = null;
      // this.loading = true;
      // this.$apollo
      //   .query({
      //     query: LOAD_STORAGE_BUILDING_QUERY,
      //     fetchPolicy: "no-cache",
      //     variables: {
      //       id: id
      //     }
      //   })
      //   .then(response => {
      //     this.editableEntry = response.data.accountContext.storageBuilding;
      //     console.log("storage_shelf", this.editableEntry);
      //     // this.extraData = response.data;
      //     // console.log(this.editableEntry, this.extraData);
      //   })
      //   .catch(response => console.log(response))
      //   .finally(() => (this.loading = false));

    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.entry.name = this.editableEntry.name;
        this.entry.buildingLevelsAttributes = this.editableEntry.buildingLevelsAttributes;
        this.$refs.baseEdit.closeDialog();
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
// movementItemAvailableQuantity
const LOAD_STORAGE_BUILDING_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      storageBuilding(id: $id) {
        id
        name
        buildingLevelsAttributes{
          id
          name                    
          buildingLevelBoxesAttributes{
            id
            name
            storageItemLotIdsAttribute
            storageItemLots{
              id
              name
            }
          }
        }
        validations
      }
    }
  }
`;

</script>

<style scoped></style>